import React from "react";
import { useTranslation } from "react-i18next";

export const TerminosCondiciones = () => {
  const [t] = useTranslation("global");

  return (
    <section className="wrapper_legals">
      <div className="box_tittle">
        <div className="container">
          <h1 className="mb-2 ttls">
            <span>{t("others.terms_conditions_one")} </span>{" "}
            {t("others.terms_conditions_two")}
          </h1>
          <h6 className="ttls_small">{t("others.website")} </h6>
        </div>
      </div>
      <div className="content_legals">
        <div className="container">
          <p>{t("terms_conditions.legal_p1")}</p>

          <p>{t("terms_conditions.legal_p2")}</p>

          <h5>1. {t("terms_conditions.title_1")}</h5>

          <p>{t("terms_conditions.legal_p3")}</p>

          <h5>2. {t("terms_conditions.title_2")}</h5>

          <p>{t("terms_conditions.legal_p4")}</p>

          <ul>
            <li>
              <strong>{t("terms_conditions.legal_p5")}</strong>
            </li>
            <li>
              <strong>{t("terms_conditions.legal_p6")}</strong>
            </li>
          </ul>

          <h5>3. {t("terms_conditions.title_3")}</h5>

          <ul>
            <li>
              <strong>{t("terms_conditions.legal_p7")}</strong>
            </li>
            <li>
              <strong>{t("terms_conditions.legal_p8")}</strong>
            </li>
          </ul>

          <h5>4. {t("terms_conditions.title_4")}</h5>

          <p>{t("terms_conditions.legal_p9")}</p>

          <ul>
            <li>{t("terms_conditions.legal_p10")}</li>
            <li>{t("terms_conditions.legal_p11")}</li>
          </ul>

          <h5>5. {t("terms_conditions.title_5")}</h5>

          <ul>
            <li>
              <strong>{t("terms_conditions.legal_p12")}</strong>
            </li>
            <li>{t("terms_conditions.legal_p13")}</li>
            <li>{t("terms_conditions.legal_p14")}</li>
            <li>
              <strong>{t("terms_conditions.legal_p15")}</strong>
            </li>
          </ul>

          <h5>7. {t("terms_conditions.title_7")}</h5>

          <p>{t("terms_conditions.legal_p16")}</p>

          <h5>8. {t("terms_conditions.title_8")}</h5>

          <p>{t("terms_conditions.legal_p17")}</p>

          <h5>9. {t("terms_conditions.title_9")}</h5>

          <p>{t("terms_conditions.legal_p18")}</p>

          <p>{t("terms_conditions.legal_p19")}</p>

          <p>
            <strong>{t("terms_conditions.legal_p20")}</strong>
          </p>
        </div>
      </div>
    </section>
  );
};
